import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  IconButton,
  Typography,
  styled,
  useTheme,
  TextField,
  Chip,
  Tooltip,
} from "@mui/material"
import { motion } from "framer-motion"
import React, { forwardRef, useContext, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { ActualizarEvaluacionPGD, EnviarCompetencias, EnviarObjetivos, clearEvaluacionesPGD, evaluacionPorPGD, itemsEvaluacionPGDFetch, objetivosPorPGD } from "../Redux/evaluaciones"
import { COLUMNSOBJETIVOS } from "../columnas/columnasObjetivos"
import TokenContext from "../context/TokenContext"
import Header from "./Header"

import { useState } from "react"
import { FormProvider, useForm } from "react-hook-form";
import { UserAuth } from "../context/AuthContext"
import ModalObjetivo from "./modales/ModalObjetivo"

import Grid from '@mui/material/Unstable_Grid2';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import "moment/locale/es";
import { getCOLUMNSITEMSEVALUACION } from '../columnas/columnasEvaluacion'
import CustomTextField from "./CustomTextField"
import ModalCompetencias from "./modales/ModalCompetencias"
import useItemsCompetencias from "./hooks/useItemsCompetencias"
import ModalDescripción from "./modales/ModalDescripcion"
import useObjetivosPGD from "./hooks/useObjetivosPGD"
import moment from "moment";
import TablaAvancesXobjetivos from "./tablas/TablaAvancesXobjetivos"
import CustomSearchSelect from "./CustomSearchSelect"
import HelpIcon from '@mui/icons-material/Help';
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { showToast } from "../utils/toast"
import ModalConfirmacion from "./modales/ModalConfirmacion"
import TablaCompetencia from "./tablas/TablaCompetencia"

const valoracionOpciones = [
  { value: 100000000, label: "Por Debajo De Las Expectativas", ponderation: 1 },
  { value: 100000001, label: "Cumple Parcialmente Las Expectativas", ponderation: 2 },
  { value: 100000002, label: "Cumple Las Expectativas", ponderation: 3 },
  { value: 100000003, label: "Por Encima De Las Expectativas", ponderation: 4 },
  { value: 100000004, label: "Sobresaliente", ponderation: 5 },
]

const estadosOpciones = [
  { value: 100000000, label: "En Curso" },
  { value: 100000001, label: "Completa" },
  { value: 100000002, label: "Incompleta" },
  { value: 100000003, label: "No Iniciado" },
  { value: 100000004, label: "No Aplica" },
]

const EvaluacionFeedback = () => {
  const dispatch = useDispatch()
  const token = useContext(TokenContext)
  const { empleado } = UserAuth()
  const theme = useTheme()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { readOnly } = location.state.readOnly || {}


  const { getPgdObjetivos, objetivosPGD, targetObjetivo, setGetPgdObjetivos, setObjetivosPGD, setTargetObjetivo, targetObjetivoCancel, setTargetObjetivoCancel, handleObjetivo, handleCancelObjetivo, openModalModo, setOpenModalModo, openModalNuevoObjetivo, setOpenModalNuevoObjetivo, openModalCancelObjetivo, setOpenModalCancelObjetivo } = useObjetivosPGD(token, id)


  const evaluacionPGDSelector = useSelector((store) => store.evaluaciones.evaluacionPGD)
  const getEvaluacionPDGSelector = useSelector((store) => store.evaluaciones.getEvaluacionPDG)

  const [evaluacionPGD, setEvaluacionPGD] = useState([]);


  const [isStateCleared, setIsStateCleared] = useState(false)

  const [isLider, setIsLider] = useState(false)
  const [idLider, setIdLider] = useState("")
  const [evaluacionFinalizada, setEvaluacionFinalizada] = useState(readOnly)


  const { getItemsEvaluacionPDG, itemsEvaluacionPGD, targetCompetencia, setGetItemsEvaluacionPDG, setItemsEvaluacionPGD, setTargetCompetencia, handleOpenModalCompetencia, handleCloseModalCompetencia, openModalCompetencia, setOpenModalCompetencia, complete, setComplete, ponderationTotal } = useItemsCompetencias(token, id)

  const [compLider, setCompLider] = useState([])
  const competenciaLselector = useSelector(store => store.autocompletados.competenciasLider)

  const [compEvaluado, setCompEvaluado] = useState([])
  const competenciaEselector = useSelector(store => store.autocompletados.competenciasEvaluado)

  const [empleadosReportaA, setEmpleadosReportaA] = useState(false)
  const empleadosReportaAselector = useSelector(store => store.evaluaciones.empleadosReportaA)

  const [leyendaObjetivos, setLeyendaObjetivos] = useState({})
  const leyendaObjetivoSelector = useSelector(store => store.autocompletados.leyendaObjetivo)

  const [leyendaEtapa1, setLeyendaEtapa1] = useState("")
  const [leyendaEtapa2, setLeyendaEtapa2] = useState("")

  const [scoreGlobalCompetenciaValor, setScoreGlobalCompetenciaValor] = useState(0);

  const [openModalConfirmacion, setOpenModalConfirmacion] = useState(false)
  const [targetModalConfirmacion, setTargetModalConfirmacion] = useState("")
  const [textoModalConfirmacion, setTextoModalConfirmacion] = useState("")

  const handleCloseModalNuevoObjetivo = (objetivo, idPGDObjetivo, indice) => {
    if (objetivo) {
      if (!objetivo.id) { // Objetivo nuevo
        if(indice == null || indice == undefined) { //Agregar objetivo nuevo
          let item = {
            id: objetivo.id ? objetivo.id : null,
            objetivo: objetivo.objetivo,
            fechaDeCarga: objetivo.fechaDeCarga ? objetivo.fechaDeCarga : null,
            fechaDeCumplimiento: objetivo.fechaDeCumplimiento ? moment(objetivo.fechaDeCumplimiento, "DD/MM/YY").format("YYYY-MM-DD") : null,
            peso: objetivo.peso,
            competencia: objetivo.competencia,
            competencia2: objetivo.competencia2 ? objetivo.competencia2 : null,
            indicador: objetivo.indicador,
            indicador2: objetivo.indicador2 ? objetivo.indicador2 : null,
            indicador3: objetivo.indicador3 ? objetivo.indicador3 : null,
            indicador4: objetivo.indicador4 ? objetivo.indicador4 : null,
            indicador5: objetivo.indicador5 ? objetivo.indicador5 : null,
            competenciaPrimaria: objetivo.competencia.label,
            competenciaSecundaria: objetivo.competencia2 ? objetivo.competencia2.label : null,
            idEvaluacion: idPGDObjetivo,
            statusSelect : { value: 100000004, label: "No iniciado" },
          }

          setObjetivosPGD((prevObjetivosPGD) => [...prevObjetivosPGD, item]);
        }
        else { // Editar Objetivo Nuevo
          const nuevosObjetivosPGD = [...objetivosPGD];
          nuevosObjetivosPGD[indice].fechaDeCumplimiento = objetivo.fechaDeCumplimiento ? (moment.isMoment(objetivo.fechaDeCumplimiento) ? moment(objetivo.fechaDeCumplimiento, "DD/MM/YY").format("YYYY-MM-DD") : objetivo.fechaDeCumplimiento): null;
          nuevosObjetivosPGD[indice].peso = objetivo.peso;
          nuevosObjetivosPGD[indice].indicador = objetivo.indicador;
          nuevosObjetivosPGD[indice].indicador2 = objetivo.indicador2;
          nuevosObjetivosPGD[indice].indicador3 = objetivo.indicador3;
          nuevosObjetivosPGD[indice].indicador4 = objetivo.indicador4;
          nuevosObjetivosPGD[indice].indicador5 = objetivo.indicador5;

          setObjetivosPGD(nuevosObjetivosPGD);
        }
      } else { //Editar Objetivo Existente en BO
        let index = objetivosPGD.findIndex((item) => item.id === objetivo.id);

        if (index !== -1) {
          const nuevosObjetivosPGD = [...objetivosPGD];
          nuevosObjetivosPGD[index].fechaDeCumplimiento = objetivo.fechaDeCumplimiento ? (moment.isMoment(objetivo.fechaDeCumplimiento) ? moment(objetivo.fechaDeCumplimiento, "DD/MM/YY").format("YYYY-MM-DD") : objetivo.fechaDeCumplimiento) : null;
          nuevosObjetivosPGD[index].peso = objetivo.peso;
          nuevosObjetivosPGD[index].indicador = objetivo.indicador;
          nuevosObjetivosPGD[index].indicador2 = objetivo.indicador2;
          nuevosObjetivosPGD[index].indicador3 = objetivo.indicador3;
          nuevosObjetivosPGD[index].indicador4 = objetivo.indicador4;
          nuevosObjetivosPGD[index].indicador5 = objetivo.indicador5;

          setObjetivosPGD(nuevosObjetivosPGD);
        }
      }
    }
    setOpenModalNuevoObjetivo(false)
    setOpenModalModo("")
    setTargetObjetivo({})
  };

  const defaultValues = {
    // fechaEncuentroFeedback: null,
    comentariosEvaluado: null,
    comentariosLider: null,
    scoreGlobalObjetivos: null,
    scoreGlobalCompetencias: null,
    estadoDeLaEtapa: null,
  }
  const validacionSchema = yup.object().shape({
    comentariosEvaluado: yup
    .string()
    .nullable()
    .max(20000, "El Feedback del Evaluado debe tener como máximo 20.000 caracteres."),
    comentariosLider: yup
    .string()
    .nullable()
    .max(20000, "El Feedback del Líder debe tener como máximo 20.000 caracteres."),
  });

  const methods = useForm({
    shouldUnregister: false,
    defaultValues,
    resolver: yupResolver(validacionSchema),
    mode: "onChange",
    shouldFocusError: true,
  })

  const { handleSubmit, reset, setValue } = methods

  useEffect(() => {
    if (empleado.empleadoid == idLider) {
      setIsLider(true)
    } else {
      setIsLider(false)
    }
  }, [idLider])

  useEffect(() => {
    if (evaluacionPGD?.length > 0) {
      if (evaluacionPGD[0]?.statuscode == 100000003) {
        setEvaluacionFinalizada(true)
      }
      reset({
        ...defaultValues,
        comentariosEvaluado: evaluacionPGD[0].comentarios,
        comentariosLider: evaluacionPGD[0].comentariosLider,
        scoreGlobalCompetencias: evaluacionPGD[0]?.new_scoreglobaldedompetencias,
        scoreGlobalObjetivos: evaluacionPGD[0]?.new_scoreglobaldeobjetivos,
        estadoDeLaEtapa: evaluacionPGD[0]?.new_estadodelencuentrodefeedback,
      })
    }
  }, [evaluacionPGD])

  useEffect(() => {
    if (competenciaLselector.length > 0) {
      const newArray = competenciaLselector.map((element) => ({
        value: element.new_competenciaid,
        label: element.new_name
      }))

      setCompLider(newArray)
    }
  }, [competenciaLselector])

  useEffect(() => {
    if (competenciaEselector.length > 0) {
      const newArray = competenciaEselector.map((element) => ({
        value: element.new_competenciaid,
        label: element.new_name
      }))

      setCompEvaluado(newArray)
    }
  }, [competenciaEselector])

  useEffect(() => {
    if (empleadosReportaAselector.length > 0) {
      setEmpleadosReportaA(true)
    } else {
      setEmpleadosReportaA(false)
    }
  }, [empleadosReportaAselector])

  useEffect(() => {
    if (leyendaObjetivoSelector.length > 0) {
      const newArray = leyendaObjetivoSelector.map((element) => ({
        id: element.new_maestrodeleyendaspgdid,
        new_nombredeobjetivo: element.new_nombredeobjetivo,
        new_pesodeobjetivo: element.new_pesodeobjetivo,
        new_resultadoclavedeobjetivo: element.new_resultadoclavedeobjetivo,
        new_competenciadeobjetivo: element.new_competenciadeobjetivo
      }))
      setLeyendaObjetivos(newArray[0])

      const definicionObjetivos = leyendaObjetivoSelector[0]?.new_autoevaluacionintroduccion;
      const gestionSeguimiento = leyendaObjetivoSelector[0]?.new_evaluacinintroduccin;

      setLeyendaEtapa1(definicionObjetivos)
      setLeyendaEtapa2(gestionSeguimiento)

    }
  }, [leyendaObjetivoSelector])

  useEffect(() => {
    if (id?.length > 0 && token) {
      setEvaluacionPGD([])
      setIsStateCleared(true)
      dispatch(evaluacionPorPGD(token, id))
    }
  }, [id, token])


  useEffect(() => {
    if (evaluacionPGDSelector?.length > 0 && getEvaluacionPDGSelector) {
      const array = []
      evaluacionPGDSelector.forEach((items) => {
        setIdLider(items["_new_lder_value"])
        let item = {
          id: items["new_evaluaciondepgdid"],
          fechafeedback: items["new_fechayhoradelencuentrodefeedback"],
          comentarios: items.new_comentariosyobservacionesdelfeedback,
          comentariosLider: items.new_comentariosyobservacionesdelfeedbacklider,
          instancia: items["statuscode@OData.Community.Display.V1.FormattedValue"],
          statuscode: items["statuscode"],
          estadoEtapa: items["new_estadodelencuentrodefeedback"],
          new_scoreglobaldeobjetivos: {
            value: items.new_scoreglobaldeobjetivos,
            label: items["new_scoreglobaldeobjetivos@OData.Community.Display.V1.FormattedValue"]
          },
          new_scoreglobaldedompetencias: {
            value: items.new_scoreglobaldedompetencias,
            label: items["new_scoreglobaldedompetencias@OData.Community.Display.V1.FormattedValue"]
          },
          new_estadodelencuentrodefeedback: {
            value: items.new_estadodelencuentrodefeedback,
            label: items["new_estadodelencuentrodefeedback@OData.Community.Display.V1.FormattedValue"]
          },
          nombreEvaluado: items["_new_evaluado_value@OData.Community.Display.V1.FormattedValue"],
        }
        
        array.push(item)
      })
      setEvaluacionPGD(array);
    }

  }, [ evaluacionPGDSelector, isStateCleared])


  useEffect(() => {

    if(ponderationTotal) {
      if(ponderationTotal <1.5) {
        setScoreGlobalCompetenciaValor(valoracionOpciones[0])
      } else if (ponderationTotal >=1.5 && ponderationTotal <2.5) {
        setScoreGlobalCompetenciaValor(valoracionOpciones[1])
      } else if (ponderationTotal >=2.5 && ponderationTotal <3.5) {
        setScoreGlobalCompetenciaValor(valoracionOpciones[2])
      } else if (ponderationTotal >=3.5 && ponderationTotal <4.5) {
        setScoreGlobalCompetenciaValor(valoracionOpciones[3])
      }else if (ponderationTotal >=4.5) {
        setScoreGlobalCompetenciaValor(valoracionOpciones[4])
      } else {
        setScoreGlobalCompetenciaValor(null)
      }

    }
  }, [ponderationTotal]);

  const handleVolverAtras = () => {
    navigate("/pgd", { state: { activeTab: location.state?.activeTab || "1" } });
    dispatch(clearEvaluacionesPGD())
  }

  const submitDataObjetivos = (datos) => {
    
    setTargetModalConfirmacion("objetivos");
    // setTextoModalConfirmacion("Desea enviar los objetivos? Una vez enviado, no podrá modificar los avances mensuales.");
    setTextoModalConfirmacion("Desea enviar los objetivos?");
    setOpenModalConfirmacion(true);

  }

  const submitDataFeedback = (datos) => {
    let filteredObject;
    if(isLider) {
      filteredObject = Object.entries(datos).reduce((obj, [key, value]) => {
        if ( (value && key === 'comentariosLider') /*|| ( value && key === 'fechaEncuentroFeedback')*/) {
            obj[key] = value;
        }
        return obj;
      }, {});
      if (!filteredObject['comentariosLider']) {
        showToast('error', "Debe completar el Feedback del Líder para enviar.");
        return;
      }
    } else {
      filteredObject = Object.entries(datos).reduce((obj, [key, value]) => {
        if ( (value && key === 'comentariosEvaluado') ) {
            obj[key] = value;
        }
        return obj;
      }, {});
      if (!filteredObject['comentariosEvaluado']) {
        showToast('error', "Debe completar el Feedback del Evaluado para enviar.");
        return;
      }
    }

    dispatch(ActualizarEvaluacionPGD(token, id, filteredObject))
    .then(() => dispatch(evaluacionPorPGD(token, id)))
    .catch((error) => console.error("Error:", error));

  }
  

  const submitDataItems = (datos) => {

    showToast('success', "Competencias enviadas correctamente!");


    // let itemsCompletados = []
    // let itemsFiltradosCompletados = []
    // let actualizarScoreCompetencias = null

    // if(isLider) {
    //   itemsCompletados = itemsEvaluacionPGD.filter((item) => item.valoracionLiderModal?.value);
    //   itemsFiltradosCompletados = itemsCompletados.map((item) => {
    //     return {
    //       new_itemdeevaluaciondedesempeoid: item.id,
    //       new_valoraciondellider: item.valoracionLiderModal?.value,
    //     };
    //   });
    //   actualizarScoreCompetencias = { "new_evaluaciondepgdid": id, "new_scoreglobaldedompetencias": scoreGlobalCompetenciaValor?.value }
    // } else {
    //   itemsCompletados = itemsEvaluacionPGD.filter((item) => item.valoracionModal?.value );
    //   itemsFiltradosCompletados = itemsCompletados.map((item) => {
    //     return {
    //       new_itemdeevaluaciondedesempeoid: item.id,
    //       new_valoracin: item.valoracionModal?.value,
    //     };
    //   });
    //   actualizarScoreCompetencias = { "new_evaluaciondepgdid": id, "new_scoreglobaldedompetencias": 0 }
    // }



    // if(itemsCompletados.length > 0 && itemsEvaluacionPGD.length == itemsCompletados.length) {

    //   // dispatch(EnviarCompetencias(token, itemsFiltradosCompletados, actualizarScoreCompetencias))
    //   // .then(() => {
    //   //   dispatch(evaluacionPorPGD(token, id))
    //   //   dispatch(itemsEvaluacionPGDFetch(token, id))
    //   // })
    //   // .catch((error) => console.error("Error:", error));
    //   showToast('success', "Competencias enviadas correctamente!");

    // }
    // else {
    //   if(isLider) {
    //     showToast('error', "Debe completar todas las valoraciones del Líder para poder guardarlas.")
    //   } else {
    //     showToast('error', "Debe completar todas las valoraciones del Evaluado para poder guardarlas.")
    //   }
    // }

  }


  const submitFinishPGD = () => {

    setTargetModalConfirmacion("finalizarEtapa");
    setTextoModalConfirmacion("¿Estas seguro de enviar evaluación? En posterior, no podrás realizar modificaciones.");
    setOpenModalConfirmacion(true)

  }
  const handleClose = (confirmacion) => {
    if(targetModalConfirmacion == "objetivos" && confirmacion) {
      showToast('success', "Objetivos enviados correctamente!");

      // dispatch(EnviarObjetivos(token, id))
      // .then(() => {
      //   dispatch(evaluacionPorPGD(token, id))
      //   dispatch(objetivosPorPGD(token, id))
      // } )
      // .catch((error) => console.error("Error:", error));

    }
    else if (targetModalConfirmacion == "finalizarEtapa") {
      let errorMessage = null;

      if (confirmacion) {
        // if (!evaluacionPGD[0].new_scoreglobaldeobjetivos?.value) {
        //   errorMessage = "Debe guardar los avances de los objetivos para finalizar la etapa";
        // }
        if (!complete) {
          errorMessage = "Competencias Incompletas, no se enviará la Evaluación Global.";
          showToast('error', errorMessage);
        }
        if (!evaluacionPGD[0].comentarios) {
          errorMessage = "Debe completar el Feedback del Evaluado para finalizar la etapa.";
          showToast('error', errorMessage);
        }
        if (!evaluacionPGD[0].comentariosLider) {
          errorMessage = "Debe completar el Feedback del Líder para finalizar la etapa.";
          showToast('error', errorMessage);
        }
      }
  
      if (confirmacion && errorMessage) {
        // let errorMessage2 = (
        //   <div>
        //     {!evaluacionPGD[0].comentarios && (
        //       <p>Debe completar el Feedback del Evaluado para finalizar la etapa.</p>
        //     )}
        //     {!evaluacionPGD[0].comentariosLider && (
        //       <p>Debe completar el Feedback del Líder para finalizar la etapa.</p>
        //     )}
        //     {!complete && (
        //       <p>Competencias Incompletas, no se enviará la Evaluación Global.</p>
        //     )}
        //   </div>
        // );
        
        // showToast('error', errorMessage);
      } else if (confirmacion && !errorMessage) {

    //   actualizarScoreCompetencias = { "new_evaluaciondepgdid": id, "new_scoreglobaldedompetencias": scoreGlobalCompetenciaValor?.value }




        let actualizarEstado = { "new_estadodelencuentrodefeedback": 100000001, "new_scoreglobaldedompetencias": scoreGlobalCompetenciaValor?.value }
        dispatch(ActualizarEvaluacionPGD(token, id, actualizarEstado))
        .then(() => {
          handleVolverAtras();
          dispatch(evaluacionPorPGD(token, id))
        })
        .catch((error) => console.error("Error:", error));
  

      }
    }
    

    setTextoModalConfirmacion("");
    setTargetModalConfirmacion("");
    setOpenModalConfirmacion(false);
  };

  // constant
  const headerSX = {
    "& .MuiCardHeader-action": { mr: 0 },
  }

  // ==============================|| CUSTOM MAIN CARD ||============================== //

  const MainCard = forwardRef(
    (
      {
        border = true,
        boxShadow,
        children,
        content = true,
        contentClass = "",
        contentSX = {},
        darkTitle,
        secondary,
        shadow,
        sx = {},
        title,
        ...others
      },
      ref
    ) => {
      const theme = useTheme()

      return (
        <Card
          ref={ref}
          {...others}
          sx={{
            border: border ? "1px solid" : "none",
            borderColor: theme.palette.primary[200] + 25,
            ":hover": {
              boxShadow: boxShadow ? shadow || "0 2px 14px 0 rgb(32 40 45 / 8%)" : "inherit",
            },
            ...sx,
          }}
        >
          {/* card header and action */}
          {title && (
            <CardHeader
              sx={headerSX}
              title={darkTitle ? <Typography variant="h3">{title}</Typography> : title}
              action={secondary}
            />
          )}

          {/* content & header divider */}
          {title && <Divider />}

          {/* card content */}
          {content && (
            <CardContent sx={contentSX} className={contentClass}>
              {children}
            </CardContent>
          )}
          {!content && children}
        </Card>
      )
    }
  )

  const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main  : theme.palette.tertiary[600],
    color: theme.palette.primary.light,
    overflow: "hidden",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(210.04deg, ${theme.palette.primary[200]} -50.94%, rgba(144, 202, 249, 0) 83.49%)`,
      borderRadius: "50%",
      top: -30,
      right: -180,
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: `linear-gradient(140.9deg, ${theme.palette.primary[200]} -14.02%, rgba(144, 202, 249, 0) 77.58%)`,
      borderRadius: "50%",
      top: -160,
      right: -130,
    },
  }))
  const [modalOpenDescripcion, setModalOpenDescription] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");

  const handleAbrirModal = (title, description, item) => {
    setModalOpenDescription(true);
    setModalTitle(title);
    setModalDescription(description);
    setTargetCompetencia(item);
  };

  const handleCloseModalDescripcion = () => {
    setModalOpenDescription(false);
    setModalTitle("");
    setModalDescription("");
    setTargetCompetencia({});
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -100 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <Box m="1.5rem 2.5rem">
        <Button variant="outlined" onClick={handleVolverAtras} sx={{ mb: 4 }}>
          <IconButton color={theme.palette.secondary[300]}>
            <ArrowBackIcon />
          </IconButton>
          <Typography color={theme.palette.secondary[300]}>Volver atrás</Typography>
        </Button>
        <Header title={"Balance y Cierre de Año"}
        subtitle= {
          <>
            <p>
            Durante esta etapa, se promueve un diálogo constructivo entre líderes y colaboradores, donde se lleva a cabo una revisión de las competencias institucionales y el alcance de los objetivos planteados a lo largo del año. Queremos reflexionar sobre los logros y desafíos alcanzados durante este 2024.
            </p>
            <p>
            Accedé a la <a href="https://ues21eduar.sharepoint.com/sites/intranet21/gestion-humana/SitePages/Desarrollo.aspx" target="_blank">Intranet</a> para más información del PGD
            </p>
          </>
        }
        />

        <Box sx={{ pb: 2 }} display="flex" flexDirection="column" alignItems="center">
        {
          isLider && (
            <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mt: "15px" }}>
              Evaluación de: {evaluacionPGD[0]?.nombreEvaluado}	
            </Typography>
          )
        }        
        </Box>

        <Box sx={{ my: 4 }}>
          <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
            Objetivos
          </Typography>
          {!getPgdObjetivos ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                py: 2,
              }}
            >
              <CircularProgress color="secondary" />
            </Box>
          ) : objetivosPGD.length > 0 ? (
              <TablaAvancesXobjetivos
                columnas={COLUMNSOBJETIVOS}
                lineas={objetivosPGD}
                header={true}
                acciones={false}
                handleOpen={handleObjetivo}
                handleCancel={handleCancelObjetivo}
                instancia={evaluacionPGD[0]?.statuscode}
                isLider={isLider}
                idPGD={id}
              />
          ) : (
            <Alert severity="info">
              <AlertTitle>Info</AlertTitle>
              Aún no tienes registros de <strong>Mis objetivos</strong>.
            </Alert>
          )}

          <Grid container direction="column" alignItems="center" justifyContent="center" item xs={12}>
            <Grid item>
              <Box sx={{ pt: 4 }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={ evaluacionFinalizada || !isLider || evaluacionPGD[0]?.statuscode !== 100000002 || evaluacionPGD[0]?.estadoEtapa === 100000001 || evaluacionPGD[0]?.new_scoreglobaldeobjetivos?.value || objetivosPGD.length === 0}
                  onClick={handleSubmit(submitDataObjetivos)}
                >
                  Guardar Objetivos
                </Button>
              </Box>
            </Grid>


            <Grid item xs={10}>
              <Box sx={{ py: 2, backgroundColor: "inherit" }}>
                <Box sx={{ pb: 2 }} display="flex" flexDirection="column" alignItems="center">
                  <Typography
                    variant="h2"
                    color="inherit"
                    sx={{ fontSize: "1.2rem" }}
                  >
                    Score Global de Objetivos
                    <Tooltip title="El score se calculará al finalizar la evaluación, basado en el peso y el estado final de los objetivos." arrow={true}>
                      <IconButton size="large">
                        <HelpIcon fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                </Box>
                <FormProvider {...methods}>
                <Grid item xs={12} sx={{ width: "100%" }}>
                    <CustomSearchSelect
                      options={valoracionOpciones}
                      type="text"
                      name="scoreGlobalObjetivos"
                      lab={evaluacionPGD[0]?.new_scoreglobaldeobjetivos?.value ? "Score Global de Objetivos" : "Score Global de Objetivos: No Evaluado"}
                      disabled
                    />
                  </Grid>
                </FormProvider>
              </Box>
            </Grid>
          </Grid>
        </Box>



        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mb: "5px" }}>
            Competencias
          </Typography>
        </Box>
        {!getItemsEvaluacionPDG ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              py: 2,
            }}
          >
            <CircularProgress color="secondary" />
          </Box>
        ) : itemsEvaluacionPGD.length > 0 ? (
          <TablaCompetencia columnas={getCOLUMNSITEMSEVALUACION(handleAbrirModal)} lineas={itemsEvaluacionPGD} handleOpen={handleOpenModalCompetencia} acciones={true} />
        ) : (
          <Alert severity="info">
            <AlertTitle>Info</AlertTitle>
            Aún no tienes registros de <strong>Competencias</strong>.
          </Alert>
        )}


      <Grid container direction="column" alignItems="center" justifyContent="center" item xs={12} sx={{ mb: 5 }}>
        <Grid item>
          <Box sx={{ pb: 3, mt: 4 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={ evaluacionFinalizada || evaluacionPGD[0]?.statuscode !== 100000002 || evaluacionPGD[0]?.estadoEtapa === 100000001 }
              onClick={handleSubmit(submitDataItems)}
            >
              Guardar Competencias
            </Button>
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Box sx={{ pb: 1, backgroundColor: "inherit" }}>
            <Box sx={{ pb: 2 }} display="flex" flexDirection="column" alignItems="center">
              <Typography
                variant="h2"
                color="inherit"
                sx={{ fontSize: "1.2rem" }}
              >
                Score Global de competencias
                <Tooltip title="El score se calculará al finalizar la evaluación y será un promedio de la evaluación del líder." arrow={true}>
                  <IconButton size="large">
                    <HelpIcon fontSize="large" />
                  </IconButton>
                </Tooltip>
              </Typography>
            </Box>
            <FormProvider {...methods}>
            <Grid item xs={12} sx={{ width: "100%" }}>
                <CustomSearchSelect
                  options={valoracionOpciones}
                  type="text"
                  name="scoreGlobalCompetencias"
                  lab={evaluacionPGD[0]?.new_scoreglobaldedompetencias?.value ? "Score Global de competencias" : "Score Global de competencias: No Evaluado"}
                  disabled
                />
              </Grid>
            </FormProvider>
          </Box>
        </Grid>
        

      </Grid>


        <CardWrapper border={false} content={false}>
          <Box sx={{ m: 5}}>

            <FormProvider {...methods}>
              <Typography variant="h5" color={theme.palette.secondary[50]} fontWeight="bold" sx={{ mt: 4 }}>
                Feedback
              </Typography>

              <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <CustomTextField
                  Component={TextField}
                  name="comentariosEvaluado"
                  label="Comentarios y Observaciones del Evaluado"
                  multiline
                  rows={4}
                  placeholder="Longitud máxima: 20.000 caracteres"
                  disabled={isLider || evaluacionPGD[0]?.statuscode !== 100000002 || evaluacionPGD[0]?.estadoEtapa === 100000001 }
                />
              </Grid>
              <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <CustomTextField
                  Component={TextField}
                  name="comentariosLider"
                  label="Comentarios y Observaciones del Lider"
                  multiline
                  rows={4}
                  placeholder="Longitud máxima: 20.000 caracteres"
                  disabled={!isLider || evaluacionPGD[0]?.statuscode !== 100000002 || evaluacionPGD[0]?.estadoEtapa === 100000001 }
                />
              </Grid>

              <Grid xs={12} sm={12} item sx={{ pt: 0, pb: 0 }}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={evaluacionFinalizada || evaluacionPGD[0]?.statuscode !== 100000002 || evaluacionPGD[0]?.estadoEtapa === 100000001 }
                  onClick={handleSubmit(submitDataFeedback)}
                >
                  Guardar Sección Feedback
                </Button>
              </Grid>
            </FormProvider>
          </Box>
        </CardWrapper>
      </Box>

      <Grid container direction="column" alignItems="center" justifyContent="center" item xs={12}>
        <Grid item>
          <Box sx={{ pb: 4, my: 2 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={ !isLider || evaluacionFinalizada || evaluacionPGD[0]?.statuscode !== 100000002 || evaluacionPGD[0]?.estadoEtapa === 100000001  }
              onClick={handleSubmit(submitFinishPGD)}
            >
              Enviar Evaluacion Global
            </Button>
          </Box>
        </Grid>
      </Grid>



      <ModalObjetivo
        open={openModalNuevoObjetivo}
        handleClose={handleCloseModalNuevoObjetivo}
        objetivo={targetObjetivo}
        openModalModo={openModalModo}
        idPGD={id}
        isLider={isLider}
        competenciasLider={compLider}
        competenciasEvaluado={compEvaluado}
        empleadosReportaA={empleadosReportaA}
        tipoAutoevaluacion={
          evaluacionPGD[0]?.statuscode === 100000000
            ? "Definición de Objetivos"
            : evaluacionPGD[0]?.statuscode === 100000001
              ? "Gestión y Seguimiento"
              : evaluacionPGD[0]?.statuscode === 100000002
                ? "Balance y Cierre de Año"
                : ""
        }
        leyenda={leyendaObjetivos}
      />
      <ModalCompetencias
        open={openModalCompetencia}
        handleClose={handleCloseModalCompetencia}
        item = {targetCompetencia}
        etapaCompleta = {evaluacionPGD[0]?.estadoEtapa === 100000001 ? true: false}
        scoreGlobalCalculado = {evaluacionPGD[0]?.new_scoreglobaldedompetencias?.value ? true: false}
        isLider={isLider}
        idPGD={id}
      />
      <ModalDescripción
        open={modalOpenDescripcion}
        handleClose={handleCloseModalDescripcion}
        item = {targetCompetencia}
        modalTitle = {modalTitle}
        modalDescription = {modalDescription}
      />
      <ModalConfirmacion
        open={openModalConfirmacion}
        handleClose={handleClose}
        texto={textoModalConfirmacion}
      />


    </motion.div>
  )
}

export default EvaluacionFeedback
